import { Component, ChangeDetectionStrategy } from '@angular/core';
@Component({
  selector: 'notification-card',

  imports: [],
  templateUrl: './notification-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './notification-card.component.scss',
})
export class NotificationCardComponent {}
